module.exports = __webpack_public_path__ + "img/user.55e4754b.svg";